<span *ngFor="let link of links; let i = index">
    <span *ngIf="!link.action">{{ link.text }}</span>
    <a
        *ngIf="link.action"
        id="{{ 'link-label-' + link.action + '-' + i }}"
        (click)="actions(link)"
        >{{ link.text }}</a
    >
</span>
